import React from 'react';
import PlatformSpace from "../../components/platform/platformSpace";
import {isMobile} from "react-device-detect";

export default function HomeSpacer() {
    return (
        <PlatformSpace height={isMobile ? 100 : 165}/>
    );
}